import { render } from "./TimelineEvent.vue?vue&type=template&id=2926242a&scoped=true&ts=true"
import script from "./TimelineEvent.vue?vue&type=script&lang=ts"
export * from "./TimelineEvent.vue?vue&type=script&lang=ts"

import "./TimelineEvent.vue?vue&type=style&index=0&id=2926242a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2926242a"]])

export default __exports__